import {Dialog, DialogPanel, DialogTitle} from "@headlessui/react";
import {XMarkIcon} from "@heroicons/react/24/outline";
import Datepicker from "react-tailwindcss-datepicker";
import {useEffect, useState} from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import {formatMoney, toDateTime} from "../utils/utils";
import classNames from "classnames";
import {SubmitButton} from "./Button";
import CurrencyInput from "react-currency-input-field";

export const PassiveIncomeSidebar = ({
                                         userData,
                                         isOpen,
                                         setIsOpen,
                                         monthlyPassiveIncome,
                                         liquidPassiveIncome,
                                         passiveIncomeEntries,
                                         portfolioNav,
                                         addPassiveIncomeEntry,
                                         removePassiveIncomeEntry
    }) => {
    const [newAmount, setNewAmount] = useState(0)
    const [title, setTitle] = useState("")
    const [confirmDeleteEntryTimestamp, setConfirmDeleteEntryTimestamp] = useState(null)

    console.log('PassiveIncomeSidebar::passiveIncomeEntries', passiveIncomeEntries)

    // Set localStorage when sidebar is opened
    useEffect(() => {
        if (isOpen) {
            localStorage.setItem('demo-passive-income-opened', 'true');
        }
    }, [isOpen]);

    if (!userData) return null

    return <Dialog open={isOpen} onClose={setIsOpen} className="relative z-50">
        <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                    <DialogPanel
                        transition
                        className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                    >
                        <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                            <div className="h-0 flex-1 overflow-y-auto">
                                <div className="bg-indigo-700 px-4 py-6 sm:px-6">
                                    <div className="flex items-center justify-between">
                                        <DialogTitle className="text-base font-semibold leading-6 text-white">💸 Edit Passive Income Sources</DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                onClick={() => setIsOpen(false)}
                                                className="relative rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-1">
                                        <p className="text-sm text-indigo-300">
                                            Here you can update your passive income sources.
                                        </p>
                                    </div>
                                </div>
                                <div className="flex flex-1 flex-col justify-between">
                                    <div className="divide-y divide-gray-200 px-4 sm:px-6">
                                        <div className="space-y-6 pb-5 pt-6">
                                            <div className="p-6 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl border border-indigo-200">
                                                <div className="flex items-center mb-4">
                                                    <div className="flex-shrink-0">
                                                        <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
                                                            <span className="text-lg">💡</span>
                                                        </div>
                                                    </div>
                                                    <div className="ml-3">
                                                        <h4 className="text-lg font-semibold text-indigo-900">
                                                            Monthly Withdrawal Amount
                                                        </h4>
                                                        <p className="text-2xl font-bold text-indigo-900 mt-1">
                                                            {formatMoney(monthlyPassiveIncome)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="text-sm text-indigo-700">
                                                    This includes {formatMoney(liquidPassiveIncome)} generated monthly from your investment returns (based on the {userData.yield}% yield) and any additional passive income you might have, such as rent or fixed income.
                                                    <br />
                                                    You can edit your passive income sources below.
                                                </p>
                                            </div>
                                            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
                                                <label htmlFor="description" className="block text-lg font-semibold text-gray-900 mb-3">
                                                    Add Passive Income Source
                                                </label>
                                                <div className="space-y-4">
                                                    <div>
                                                        <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2">
                                                            Title
                                                        </label>
                                                        <input
                                                            id="title"
                                                            name="title"
                                                            type="text"
                                                            value={title}
                                                            placeholder="Rent, Fixed Income, etc."
                                                            onChange={(e) => setTitle(e.target.value)}
                                                            className="w-full rounded-xl border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-2">
                                                            Amount
                                                        </label>
                                                        <CurrencyInput
                                                            id="amount"
                                                            name="amount"
                                                            placeholder="Amount"
                                                            defaultValue={0}
                                                            value={newAmount}
                                                            className="w-full rounded-xl border-0 py-3 px-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-sm"
                                                            decimalsLimit={2}
                                                            onValueChange={(value, name, values) => setNewAmount(parseFloat(value || 0))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                {passiveIncomeEntries.length > 0 ? <>
                                    <hr />
                                    <div className="flex flex-1 flex-col justify-between">
                                    <div className="divide-gray-200 px-4 sm:px-6">
                                        <div className="mt-5 mb-3 text-base font-semibold leading-6 text-gray-900">Passive Income Sources</div>
                                        <table className="min-w-full divide-y divide-gray-300">
                                            <thead>
                                            <tr>
                                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                                    Title
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Amount
                                                </th>
                                                <th scope="col" className="py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Actions
                                                </th>

                                            </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                            {passiveIncomeEntries.sort((a,b) => b.loggedAt.seconds - a.loggedAt.seconds).map((entry) => (
                                                <tr key={entry.loggedAt.seconds}>
                                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                                        {entry.title}
                                                    </td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatMoney(entry.amountInCents/100)}</td>
                                                    <td className="whitespace-nowrap py-4 text-sm text-gray-500">
                                                        {confirmDeleteEntryTimestamp === entry.id ? (
                                                                <button
                                                                    onClick={async () => {
                                                                        await removePassiveIncomeEntry(entry.id)
                                                                    }}
                                                                    type="button"
                                                                    className={classNames(
                                                                        "rounded-full px-2.5 py-1 text-xs font-semibold shadow-sm ring-1 ring-inset",
                                                                        "bg-red-500 text-red-50 ring-red-300 hover:bg-red-500 "
                                                                    )}
                                                                >
                                                                    Confirm
                                                                </button>) :
                                                            <button
                                                                onClick={() => {
                                                                    setConfirmDeleteEntryTimestamp(entry.id)
                                                                }}
                                                                type="button"
                                                                className={classNames(
                                                                    "rounded-full px-2.5 py-1 text-xs font-semibold shadow-sm ring-1 ring-inset",
                                                                    " bg-red text-red-900 ring-red-300 hover:bg-red-50 "
                                                                )}
                                                            >
                                                                &nbsp;Delete&nbsp;&nbsp;
                                                            </button>}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                </>: null}
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                <button
                                    type="button"
                                    onClick={() => setIsOpen(false)}
                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                                <SubmitButton
                                    text={"Update"}
                                    loadingText={"Updating..."}
                                    onSubmit={async () => {
                                        await addPassiveIncomeEntry({
                                            title: title,
                                            amountInCents: newAmount * 100,
                                        })
                                        setTitle("")
                                        setNewAmount(0)
                                    }}
                                    />
                            </div>
                            </div>
                        </form>
                    </DialogPanel>
                </div>
            </div>
        </div>
    </Dialog>
}
